<template>
  <template v-if="!isAuthenticated || route.name === 'loading'">
    <div class="w-full">
      <RouterView />
    </div>
  </template>

  <template v-else>
    <DefaultLayout />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {useCurrentUserStore} from "@/stores/current-user-store.ts";

const route = useRoute();

const currentUserStore = useCurrentUserStore()

const isAuthenticated = computed(() => currentUserStore.currentUser !== null)
</script>
